
import Vue from "vue";
import { IBreadCrumb } from "winfakt-vue-components";
import AppMobileFullScreenContainer from "@/components/common/MobileFullScreenContainer.vue";
import AppToolbar from "@/components/common/ToolbarBase.vue";
import AppMailTemplateEdit from "@/components/mail-template-editor/MailTemplateEdit.vue";
import { DossierConfigService } from "@/services/dossier-config-service";

export default Vue.extend({
	data() {
		return {
			config: DossierConfigService.getPortalConfig()
		};
	},
	computed: {
		path(): IBreadCrumb[] {
			return [
				{
					to: "/settings/sales", value: this.$ct("sale/purchase")
				},
				{
					value: this.$ct("client-portal"),
					to: "/settings/sales/client-portal"
				},
				{
					value: this.$ct("client-portal-email"),
				}
			] as IBreadCrumb[];
		}
	},
	methods: {
		save() {
			DossierConfigService.setPortalConfig(this.config);
			this.$wf.notify(this.$ct("template-saved").toString(), "success", 2000);
		}
	},
	components: {
		AppMailTemplateEdit,
		AppMobileFullScreenContainer,
		AppToolbar
	},
	i18nEx: {
		componentPrefix: "components.sale-settings"
	}
});
